import { useQuery } from "react-query";
import api from "../api";

export const useGetAppConfig = () => {
  return useQuery(["app-config"], () => {
    return api.get("app-config").then((res) => res.data);
  });
};
